(function () {
  var STORAGE_KEY = 'do-wishlist';

  function read() {
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  var domSyncPaused = false;
  var observerTimer;

  function setDrawerPanel(panel) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('data-drawer-panel', panel);
    applyPanel();
  }

  function invalidateWishlistSignature() {
    var list = document.querySelector('[data-wishlist-list]');
    if (list) list.removeAttribute('data-signature');
  }

  function removeWishlistArticle(button) {
    var article = button && button.closest('.drawer__wishlist-item');
    if (!article) return;
    article.remove();
    var list = document.querySelector('[data-wishlist-list]');
    if (list && !list.querySelector('.drawer__wishlist-item')) {
      list.innerHTML = wishlistEmptyHtml();
    }
    invalidateWishlistSignature();
  }

  function applyCartIconBubble(sectionHtml) {
    if (!sectionHtml) return;
    var target = document.getElementById('cart-icon-bubble');
    if (!target) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var section = doc.querySelector('.shopify-section');
    if (section) target.innerHTML = section.innerHTML;
  }

  function patchCartDrawerFromSection(sectionHtml) {
    if (!sectionHtml) return;
    var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var sourceItems = doc.querySelector('cart-drawer-items');
    var targetItems = document.querySelector('cart-drawer cart-drawer-items');
    if (sourceItems && targetItems) {
      targetItems.innerHTML = sourceItems.innerHTML;
      targetItems.className = sourceItems.className;
    }
    var sourceFooter = doc.querySelector('.drawer__footer');
    var targetFooter = document.querySelector('cart-drawer .drawer__footer');
    if (sourceFooter && targetFooter) targetFooter.innerHTML = sourceFooter.innerHTML;
    var sourceDrawer = doc.querySelector('cart-drawer');
    var targetDrawer = document.querySelector('cart-drawer');
    if (sourceDrawer && targetDrawer) {
      targetDrawer.classList.toggle('is-empty', sourceDrawer.classList.contains('is-empty'));
    }
    if (typeof window.reattachCartDrawerListeners === 'function') window.reattachCartDrawerListeners();
  }

  function applyCartSections(state) {
    if (!state || !state.sections) return;
    domSyncPaused = true;
    applyCartIconBubble(state.sections['cart-icon-bubble']);
    patchCartDrawerFromSection(state.sections['cart-drawer']);
    domSyncPaused = false;
    applyPanel();
    syncHearts();
  }

  function formatMoney(cents, moneyFormat) {
    var amount = (cents / 100).toFixed(2);
    return (moneyFormat || '£{{amount}}')
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/<[^>]+>/g, '');
  }

  function applyPanel() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var panel = drawer.getAttribute('data-drawer-panel') || 'cart';
    drawer.querySelectorAll('[data-drawer-tab]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.getAttribute('data-drawer-tab') === panel);
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function getCartTableBody() {
    var tbody = document.querySelector('cart-drawer-items .cart-items tbody');
    if (tbody) return tbody;
    var contents = document.getElementById('CartDrawer-CartItems');
    if (!contents) return null;
    var wrapper = contents.querySelector('.drawer__cart-items-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'drawer__cart-items-wrapper';
      wrapper.innerHTML =
        '<table class="cart-items" role="table"><tbody role="rowgroup"></tbody></table>';
      var liveRegion = contents.querySelector('#CartDrawer-LiveRegionText');
      if (liveRegion) contents.insertBefore(wrapper, liveRegion);
      else contents.appendChild(wrapper);
    }
    return wrapper.querySelector('tbody');
  }

  function buildOptimisticCartRow(item) {
    var root = document.querySelector('[data-wishlist]');
    var moneyFormat = root && root.getAttribute('data-money-format');
    var options = (item.options || []).filter(Boolean).join(' / ');
    var price = formatMoney(item.price, moneyFormat);
    return (
      '<tr class="cart-item cart-item--pending" data-variant-id="' + escapeHtml(item.id) + '" data-pending="true" aria-busy="true">' +
      '<td class="cart-item__media">' +
      (item.image
        ? '<img class="cart-item__image" src="' + escapeHtml(item.image) + '" alt="">'
        : '') +
      '</td>' +
      '<td class="cart-item__details">' +
      '<a href="' + escapeHtml(item.url) + '" class="cart-item__name h4 break">' + escapeHtml(item.title) + '</a>' +
      '<div class="cart-item__price-wrapper"><span class="cart-item__unit-price">' + escapeHtml(price) + '</span></div>' +
      (options ? '<p class="cart-item__variant">' + escapeHtml(options) + '</p>' : '') +
      '</td>' +
      '<td class="cart-item__totals right" role="cell"></td>' +
      '<td class="cart-item__quantity" role="cell">' +
      '<div class="cart-item__quantity-row">' +
      '<div class="quantity cart-quantity cart-item__quantity-pending" aria-hidden="true">' +
      '<span class="cart-item__quantity-pending-value">1</span>' +
      '</div></div></td></tr>'
    );
  }

  function insertOptimisticCartLine(item) {
    if (!item || !item.id) return;
    var drawer = document.querySelector('cart-drawer');
    var itemsEl = document.querySelector('cart-drawer-items');
    if (drawer) drawer.classList.remove('is-empty');
    if (itemsEl) itemsEl.classList.remove('is-empty');
    var tbody = getCartTableBody();
    if (!tbody) return;
    tbody.querySelectorAll('.cart-item--pending[data-variant-id="' + item.id + '"]').forEach(function (row) {
      row.remove();
    });
    tbody.insertAdjacentHTML('afterbegin', buildOptimisticCartRow(item));
    if (drawer) drawer.setAttribute('data-cart-syncing', 'true');
  }

  function clearOptimisticCartLines() {
    document.querySelectorAll('.cart-item--pending').forEach(function (row) {
      row.remove();
    });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.removeAttribute('data-cart-syncing');
  }

  function wishlistEmptyHtml() {
    var root = document.querySelector('[data-wishlist]');
    var heading = (root && root.getAttribute('data-empty-heading')) || 'Your wishlist is empty';
    var continueUrl = (root && root.getAttribute('data-continue-url')) || '/collections/all';
    var continueLabel = (root && root.getAttribute('data-continue-label')) || 'Continue shopping';
    return (
      '<div class="drawer__wishlist-empty-wrap">' +
      '<div class="drawer__wishlist-empty-content">' +
      '<h2 class="drawer__wishlist-empty-heading">' + escapeHtml(heading) + '</h2>' +
      '<a href="' + escapeHtml(continueUrl) + '" class="button drawer__wishlist-continue">' +
      escapeHtml(continueLabel) +
      '</a>' +
      '</div></div>'
    );
  }

  function sizesHtml(item) {
    if (!item.sizes || item.sizes.length < 2) return '';
    return (
      '<div class="drawer__wishlist-sizes" role="group" aria-label="Size">' +
      item.sizes
        .map(function (size) {
          var selected = String(size.id) === String(item.id);
          return (
            '<button type="button" class="drawer__wishlist-size' + (selected ? ' is-selected' : '') + '"' +
            ' data-wishlist-size="' + escapeHtml(item.id) + '" data-size-id="' + escapeHtml(size.id) + '"' +
            ' aria-pressed="' + (selected ? 'true' : 'false') + '"' +
            (size.available ? '' : ' disabled') + '>' +
            escapeHtml(size.name) +
            '</button>'
          );
        })
        .join('') +
      '</div>'
    );
  }

  var cartVariantIds = {};
  var cartIdsInFlight = false;

  // Which wishlist variants are already in the cart, so their button can read "In cart".
  function refreshCartIds() {
    if (cartIdsInFlight) return;
    cartIdsInFlight = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var next = {};
        (cart.items || []).forEach(function (line) { next[String(line.variant_id)] = true; });
        var changed = Object.keys(next).sort().join(',') !== Object.keys(cartVariantIds).sort().join(',');
        cartVariantIds = next;
        if (changed) {
          invalidateWishlistSignature();
          render();
        }
      })
      .catch(function () {})
      .then(function () { cartIdsInFlight = false; });
  }

  function render() {
    var root = document.querySelector('[data-wishlist]');
    var list = document.querySelector('[data-wishlist-list]');
    if (!root || !list) return;
    var items = read();
    loadMissingSizes();
    if (items.length) refreshCartIds();
    var signature = items.map(function (item) {
      return item.id + (item.sizes ? ':s' + item.sizes.length : '') + (cartVariantIds[String(item.id)] ? ':c' : '');
    }).join(',');
    if (!items.length) {
      if (list.getAttribute('data-signature') === signature && list.firstElementChild) return;
      list.innerHTML = wishlistEmptyHtml();
      list.setAttribute('data-signature', signature);
      return;
    }
    // The cart drawer section re-render replaces the whole #CartDrawer markup, which
    // resets this list to an empty server-rendered node; never trust the signature then.
    if (list.getAttribute('data-signature') === signature && list.firstElementChild) return;
    list.setAttribute('data-signature', signature);
    var moneyFormat = root.getAttribute('data-money-format');
    var addLabel = root.getAttribute('data-add-label') || 'Add to cart';
    var soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';
    list.innerHTML = items
      .map(function (item) {
        var options = (item.options || []).filter(Boolean).join(' / ');
        var soldOut = item.available === false;
        var inCart = !soldOut && Boolean(cartVariantIds[String(item.id)]);
        return (
          '<article class="drawer__wishlist-item">' +
          '<img src="' + escapeHtml(item.image) + '" alt="">' +
          '<div class="drawer__wishlist-copy">' +
          '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
          '<p>' + escapeHtml(formatMoney(item.price, moneyFormat)) + '</p>' +
          (options ? '<p>' + escapeHtml(options) + '</p>' : '') +
          sizesHtml(item) +
          '</div>' +
          '<div class="drawer__wishlist-actions">' +
          '<button type="button" class="drawer__wishlist-add' + (inCart ? ' is-in-cart' : '') + '" data-wishlist-add="' + escapeHtml(item.id) + '"' +
          (soldOut || inCart ? ' disabled' : '') + '>' +
          (soldOut ? '' : '<i class="fa-sharp fa-regular ' + (inCart ? 'fa-check' : 'fa-plus') + '" aria-hidden="true"></i>') +
          escapeHtml(soldOut ? soldOutLabel : inCart ? 'In cart' : addLabel) +
          '</button>' +
          '<button type="button" class="drawer__wishlist-bin" data-wishlist-remove="' + escapeHtml(item.id) + '" aria-label="Remove from wishlist">' +
          '<i class="fa-sharp fa-regular fa-trash" aria-hidden="true"></i>' +
          '</button>' +
          '</div>' +
          '</article>'
        );
      })
      .join('');
  }

  function addWishlistItem(button) {
    var id = button.getAttribute('data-wishlist-add');
    if (!id || button.disabled) return;

    var drawer = document.querySelector('cart-drawer');
    var savedItem = read().find(function (entry) { return String(entry.id) === String(id); });

    // The item stays in the wishlist (it is a standing "saved for later" list); only the cart changes.
    domSyncPaused = true;
    if (savedItem) insertOptimisticCartLine(savedItem);
    setDrawerPanel('cart');
    if (drawer && !drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open(button);
    domSyncPaused = false;

    var formData = new FormData();
    formData.append('id', id);
    formData.append('quantity', '1');
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!drawer) return;
        if (!result.ok) {
          clearOptimisticCartLines();
          drawer.setAttribute('data-drawer-panel', 'wishlist');
          applyPanel();
          if (button) {
            button.disabled = true;
            var soldOutLabel =
              (document.querySelector('[data-wishlist]') || {}).getAttribute &&
              document.querySelector('[data-wishlist]').getAttribute('data-sold-out-label');
            button.textContent = soldOutLabel || 'Sold out';
          }
          return;
        }
        applyCartSections(result.data);
        clearOptimisticCartLines();
        drawer.classList.remove('is-empty');
        setDrawerPanel('cart');
        refreshCartIds();
      })
      .catch(function () {
        clearOptimisticCartLines();
        if (drawer) {
          drawer.setAttribute('data-drawer-panel', 'wishlist');
          applyPanel();
        }
      });
  }

  function syncHearts() {
    var saved = {};
    read().forEach(function (item) {
      saved[String(item.id)] = true;
      (item.sizes || []).forEach(function (size) { saved[String(size.id)] = true; });
    });
    document.querySelectorAll('.card-media-action--save').forEach(function (button) {
      var savedItem = saved[button.getAttribute('data-variant-id')];
      button.classList.toggle('is-saved', Boolean(savedItem));
      var icon = button.querySelector('i');
      if (!icon) return;
      icon.className = savedItem ? 'fa-sharp fa-solid fa-heart' : 'fa-sharp fa-regular fa-heart';
    });
  }

  function optionName(option) {
    return String(typeof option === 'string' ? option : (option && option.name) || '').toLowerCase();
  }

  function sizeOptionIndex(product) {
    return (product.options || []).findIndex(function (option) {
      return optionName(option).indexOf('size') !== -1;
    });
  }

  function variantOptions(variant) {
    return [variant.option1, variant.option2, variant.option3];
  }

  function variantImage(variant) {
    if (variant.image) return variant.image;
    var featured = variant.featured_image;
    return (featured && (featured.src || featured)) || '';
  }

  // Every size of the same colour/style as `variant`, so the wishlist can switch size in place.
  function sizesFromProduct(product, variant) {
    var sizeIndex = sizeOptionIndex(product);
    if (sizeIndex < 0) return [];
    var current = variantOptions(variant);
    var sizes = [];
    (product.variants || []).forEach(function (entry) {
      var options = variantOptions(entry);
      var sameStyle = options.every(function (value, index) {
        return index === sizeIndex || value === current[index];
      });
      if (!sameStyle || !options[sizeIndex]) return;
      sizes.push({
        id: entry.id,
        name: options[sizeIndex],
        available: entry.available !== false,
        price: entry.price,
        image: variantImage(entry)
      });
    });
    return sizes;
  }

  function itemFromProduct(product, variant, image) {
    var sizeIndex = sizeOptionIndex(product);
    return {
      id: variant.id,
      title: product.title,
      url: product.url + '?variant=' + variant.id,
      price: variant.price,
      image: image || variantImage(variant),
      available: variant.available !== false,
      options: variantOptions(variant).filter(Boolean),
      size: sizeIndex >= 0 ? variantOptions(variant)[sizeIndex] || '' : '',
      sizes: sizesFromProduct(product, variant)
    };
  }

  var sizeFetches = {};

  // Items saved before sizes were stored (or moved over from the cart) get them from the product JSON.
  function loadMissingSizes() {
    read().forEach(function (item) {
      if (item.sizes || !item.url || sizeFetches[item.id]) return;
      sizeFetches[item.id] = true;
      var path = item.url.split('?')[0] + '.js';
      fetch(path)
        .then(function (response) { return response.json(); })
        .then(function (product) {
          var variant = (product.variants || []).find(function (entry) {
            return String(entry.id) === String(item.id);
          });
          if (!variant) return;
          var items = read();
          var saved = items.find(function (entry) { return String(entry.id) === String(item.id); });
          if (!saved) return;
          var sizeIndex = sizeOptionIndex(product);
          saved.sizes = sizesFromProduct(product, variant);
          saved.size = sizeIndex >= 0 ? variantOptions(variant)[sizeIndex] || '' : '';
          write(items);
          invalidateWishlistSignature();
          render();
        })
        .catch(function () {});
    });
  }

  function savedIndex(variantId) {
    return read().findIndex(function (entry) {
      return String(entry.id) === String(variantId) || (entry.sizes || []).some(function (size) {
        return String(size.id) === String(variantId);
      });
    });
  }

  function saveToWishlist(item, trigger) {
    if (!item || !item.id) return;
    var items = read();
    if (!items.some(function (entry) { return String(entry.id) === String(item.id); })) {
      items.push(item);
      write(items);
    }
    syncHearts();
    openWishlist(trigger);
  }

  function selectWishlistSize(button) {
    var itemId = button.getAttribute('data-wishlist-size');
    var sizeId = button.getAttribute('data-size-id');
    var items = read();
    var item = items.find(function (entry) { return String(entry.id) === String(itemId); });
    if (!item || !item.sizes || String(itemId) === String(sizeId)) return;
    var next = item.sizes.find(function (size) { return String(size.id) === String(sizeId); });
    if (!next) return;
    var previousSize = item.size;
    item.options = (item.options || []).map(function (value) { return value === previousSize ? next.name : value; });
    item.id = next.id;
    item.size = next.name;
    item.price = next.price;
    item.available = next.available;
    if (next.image) item.image = next.image;
    item.url = item.url.split('?')[0] + '?variant=' + next.id;
    // Choosing a size that is already saved on its own entry merges into this one.
    write(items.filter(function (entry) {
      return entry === item || String(entry.id) !== String(next.id);
    }));
    syncHearts();
    invalidateWishlistSignature();
    render();
  }

  function openWishlist(trigger) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    setDrawerPanel('wishlist');
    render();
    if (!drawer.classList.contains('active') && typeof drawer.open === 'function') drawer.open(trigger);
  }

  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      var removeId = removeButton.getAttribute('data-wishlist-remove');
      removeWishlistArticle(removeButton);
      write(read().filter(function (entry) { return String(entry.id) !== String(removeId); }));
      syncHearts();
      invalidateWishlistSignature();
      render();
      return;
    }

    var addButton = event.target.closest('[data-wishlist-add]');
    if (addButton) {
      event.preventDefault();
      event.stopPropagation();
      addWishlistItem(addButton);
      return;
    }

    var sizeButton = event.target.closest('[data-wishlist-size]');
    if (sizeButton) {
      event.preventDefault();
      event.stopPropagation();
      selectWishlistSize(sizeButton);
      return;
    }

    var tab = event.target.closest('[data-drawer-tab]');
    if (tab) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;
      drawer.setAttribute('data-drawer-panel', tab.getAttribute('data-drawer-tab'));
      applyPanel();
      render();
      return;
    }

    var heart = event.target.closest('.card-media-action--save');
    if (!heart) return;
    event.preventDefault();
    event.stopPropagation();
    var index = savedIndex(heart.getAttribute('data-variant-id'));
    if (index >= 0) {
      var items = read();
      items.splice(index, 1);
      write(items);
      syncHearts();
      invalidateWishlistSignature();
      render();
      return;
    }
    // Not saved yet: pick colour/size in the quick-add sheet ("Add to Wishlist" mode).
    document.dispatchEvent(new CustomEvent('do:wishlist-open-panel', { detail: { button: heart } }));
  }, true);

  document.addEventListener('do:wishlist-save', function (event) {
    var detail = event.detail || {};
    var product = detail.product;
    if (!product) return;
    var variant = (product.variants || []).find(function (entry) {
      return String(entry.id) === String(detail.variantId);
    });
    if (!variant) return;
    saveToWishlist(itemFromProduct(product, variant, detail.image), null);
  });

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function () {
      if (domSyncPaused) return;
      clearTimeout(observerTimer);
      observerTimer = setTimeout(function () {
        applyPanel();
        render();
        syncHearts();
      }, 80);
    }).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyPanel();
      render();
      syncHearts();
    });
  } else {
    applyPanel();
    render();
    syncHearts();
  }
})();
